/**
 * Durga Puja 2026 date & time table, as published by SORRBA.
 *
 * tithi   name of the tithi / ritual
 * date    calendar date, already formatted for display
 * day     weekday
 * time    end time of the tithi ("Upto ..."); null when none is published
 */
export const PUJA_YEAR = 2026;

export const PUJA_TIMETABLE = [
  { tithi: "Sasthi", date: "16 October 2026", day: "Friday", time: "03:47 am Night" },
  { tithi: "Saptami", date: "17 October 2026", day: "Saturday", time: "05:53 am Morning" },
  { tithi: "Saptami", date: "18 October 2026", day: "Sunday", time: null },
  { tithi: "Maha Ashtami", date: "19 October 2026", day: "Monday", time: "07:50 am Morning" },
  { tithi: "Sandhi Puja", date: "19 October 2026", day: "Monday", time: "07:26 am Morning" },
  { tithi: "Sandhi Puja Balidan", date: "19 October 2026", day: "Monday", time: "07:50 am Morning" },
  { tithi: "Sandhi Puja End", date: "19 October 2026", day: "Monday", time: "08:14 am Morning" },
  { tithi: "Maha Nabami", date: "20 October 2026", day: "Tuesday", time: "09:31 am Morning" },
  { tithi: "Bijoya Dashami", date: "21 October 2026", day: "Wednesday", time: "10:47 am Morning" },
];

export const PUJA_DASHAMI_RITUALS =
  "Aparajita Puja, Dadhikarma, Devi Bisarjan, Debi Baran, Sindur Utsav.";

/** Bengali panel — the same calendar, as printed on the published poster. */
export const PUJA_TIMETABLE_BN_TITLE = "২০২৬ দুর্গা পূজার সময়সূচী";

export const PUJA_TIMETABLE_BN = [
  { tithi: "মহালয়া", date: "১০ অক্টোবর ২০২৬", day: "শনিবার" },
  { tithi: "পঞ্চমী", date: "১৫ অক্টোবর ২০২৬", day: "বৃহস্পতিবার" },
  { tithi: "ষষ্ঠী", date: "১৬ অক্টোবর ২০২৬", day: "শুক্রবার" },
  { tithi: "সপ্তমী", date: "১৭ অক্টোবর ২০২৬", day: "শনিবার" },
  { tithi: "মহাসপ্তমী", date: "১৮ অক্টোবর ২০২৬", day: "রবিবার" },
  { tithi: "মহাঅষ্টমী", date: "১৯ অক্টোবর ২০২৬", day: "সোমবার" },
  { tithi: "মহানবমী", date: "২০ অক্টোবর ২০২৬", day: "মঙ্গলবার" },
  { tithi: "দশমী", date: "২১ অক্টোবর ২০২৬", day: "বুধবার" },
];

export const PUJA_TIMETABLE_BN_NOTE = {
  label: "বিজয়া দশমী",
  text: "সময় - সকাল ১০:৪৭ টা পর্যন্ত",
};
